// // // src/utils/emailService.js
// // const BACKEND_URL = "http://localhost:4000";

// // async function callEmailAPI(endpoint, data) {
// //   try {
// //     const res = await fetch(`${BACKEND_URL}${endpoint}`, {
// //       method: "POST",
// //       headers: { "Content-Type": "application/json" },
// //       body: JSON.stringify(data),
// //     });
// //     const result = await res.json();
// //     console.log(`✅ Email API ${endpoint}:`, result);
// //     return result;
// //   } catch (err) {
// //     console.error(`❌ Email API error (${endpoint}):`, err);
// //   }
// // }

import apiConfig from "./apiConfig";

const BACKEND_URL = apiConfig.BACKEND_URL;

//const BACKEND_URL = "http://localhost:4000";

async function callEmailAPI(endpoint, data) {
  try {
    console.log("Calling email API:", endpoint, data);
    const response = await fetch(`${BACKEND_URL}${endpoint}`, {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify(data),
    });
    const result = await response.json();
    console.log("Email API response:", result);
    return result;
  } catch (err) {
    console.error("Email API error:", err);
    throw err;
  }
}

// 1. Welcome email — called on signup
export async function sendWelcomeEmail(userEmail, userName, userId) {
  console.log(userEmail)
  console.log(userName)
  console.log(userId)
  await callEmailAPI("/email/welcome", {
    userEmail,
    userName,
    userId,
    price: "$1.99",
  });
}

// 2. Payment success — called after Stripe confirms payment
export async function sendPaymentSuccessEmail(userEmail, userName, transactionId, amount) {
  await callEmailAPI("/email/payment-success", {
    userEmail,
    userName,
    transactionId,
    amount,
  });
}

// 3. Payment failed — called when Stripe returns error
export async function sendPaymentFailedEmail(userEmail, userName, errorMessage, amount) {
  await callEmailAPI("/email/payment-failed", {
    userEmail,
    userName,
    errorMessage,
    amount,
  });
}

// // // 4. Support request — called from support form
// // export async function sendSupportEmail(firstName, lastName, email, topic, message, userId) {
// //   const res = await fetch(`${BACKEND_URL}/email/support`, {
// //     method: "POST",
// //     headers: { "Content-Type": "application/json" },
// //     body: JSON.stringify({ firstName, lastName, email, topic, message, userId }),
// //   });
// //   if (!res.ok) throw new Error("Failed to send support email");
// // }


export async function sendSupportEmail(
  firstName, lastName, email, topic, message, userId, ticketId
) {
  return callEmailAPI("/email/support", {
    firstName,
    lastName,
    email,
    topic,
    message,
    userId,
    ticketId,
  });
}